/********* SINGLE *********/

export const GET_ORDER_INVOICE = 'GET_ORDER_INVOICE'
export const GET_ORDER_INVOICE_OK = 'GET_ORDER_INVOICE_OK'
export const GET_ORDER_INVOICE_ERR = 'GET_ORDER_INVOICE_ERR'
export const DO_ORDER_INVOICE_CLEANUP = 'DO_ORDER_INVOICE_CLEANUP'